import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { PaymentProvider } from "../../providers/payments";

@Pipe({
  name: "countryById"
})
export class CountryPipe implements PipeTransform {
  constructor(
    private paymentprovider: PaymentProvider
  ) { }

  transform(idCountry: string = null): Observable<any> {
    if (idCountry) {
      return this.paymentprovider.getCountryById(idCountry);
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/country/country.ts